import { Link } from 'react-router-dom'

const Home = () => {
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
  return (
    <div className='pt-10 flex items-center justify-center'>
      <ul className=' text-slate-300 font-bold leading-loose text-xl sm:text-4xl sm:leading-loose md:text-5xl md:leading-loose lg:text-6xl lg:leading-loose xl:text-7xl xl:leading-loose 2xl:text-8xl 2xl:leading-loose text-center'>
        <li className='cursor-pointer hover:text-cyan-500 transition-all ease-in duration-500 pr-5'>
          <Link to='/bai' onClick={scrollTop}>Bài Ca Hướng Đạo Việt Nam</Link>
        </li>
        <li className='cursor-pointer hover:text-cyan-500 transition-all ease-in duration-500 pr-5'>
          <Link to='/quoc' onClick={scrollTop}>Quốc Ca Việt Nam</Link>
        </li>
        <li className='cursor-pointer hover:text-cyan-500 transition-all ease-in duration-500 pr-5'>
          <Link to='/us' onClick={scrollTop}>US National Anthem</Link>
        </li>
        <li className='cursor-pointer hover:text-cyan-500 transition-all ease-in duration-500 pr-5'>
          <Link to='/loi' onClick={scrollTop}>10 Điều Luật Hướng Đạo</Link>
        </li>
        <li className='cursor-pointer hover:text-cyan-500 transition-all ease-in duration-500 pr-5'>
          <Link to='/moi' onClick={scrollTop}>Mừng Anh Mới Tới</Link>
        </li>
        <li className='cursor-pointer hover:text-cyan-500 transition-all ease-in duration-500'>
          <Link to='/anh' onClick={scrollTop}>Anh Em Ta Về</Link>
        </li>
        <li className='cursor-pointer hover:text-cyan-500 transition-all ease-in duration-500'>
          <Link to='/vui' onClick={scrollTop}>Lúc Thú Vui Này</Link>
        </li>
      </ul>
    </div>
  )
}

export default Home
